module.exports = __webpack_public_path__ + "img/noFound.2a8961d8.png";